// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var ClaimTypeCode;
(function (ClaimTypeCode) {
    ClaimTypeCode["PHA"] = "PHA";
    ClaimTypeCode["MED"] = "MED";
})(ClaimTypeCode || (ClaimTypeCode = {}));
//# sourceMappingURL=claimTypeCode.js.map